import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { getUser, getUserPostStatuses } from "selectors/commonSelectors";
import {
  getAccountsGroups,
  getSelectedAccountIds,
} from "selectors/skedCoreSelectors";
import { hasApprovalWorkflows } from "utils/feature-gates";
import { visiblePostStatuses } from "utils/status-visibility";

const EMPTY_KEYS: string[] = [];
export function useVisiblePostStatuses(
  accountIds?: string[],
  currentKeys: string[] = EMPTY_KEYS
) {
  // Callers can pass freshly constructed account/current-key arrays without
  // causing filter effects to fire again for the same selection.
  const contextKey = JSON.stringify({ accountIds, currentKeys });
  const selector = useMemo(() => {
    const context = JSON.parse(contextKey) as {
      accountIds?: string[];
      currentKeys: string[];
    };
    return createSelector(
      [getUser, getUserPostStatuses, getSelectedAccountIds, getAccountsGroups],
      (user, statuses, selectedIds, groups) =>
        visiblePostStatuses(statuses, {
          enabled: hasApprovalWorkflows(user),
          accountIds: context.accountIds ?? selectedIds,
          groups,
          currentKeys: context.currentKeys,
        })
    );
  }, [contextKey]);
  return useSelector(selector);
}
